import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { PaymentMethod, PaymentMethods, PaymentMethodsType } from '@cargos/sprintpay-models';
import { Subject, takeUntil } from 'rxjs';
import { PaymentMethodsService } from 'src/app/shared/services';
import { PaymentMethodsHandlerService } from '../../shared/services/payment-methods-handler.service';
import { LogoPaymentMethodComponent } from '../logo-payment-method/logo-payment-method.component';
import { PaypalMaterialModule } from './paypal-material-modules.module';

@Component({
    standalone: true,
    imports: [LogoPaymentMethodComponent, PaypalMaterialModule],
    selector: 'app-paypal',
    templateUrl: './paypal.component.html',
    styleUrls: ['./paypal.component.scss'],
})
export class PaypalComponent implements OnInit, OnDestroy {
    public paypal?: PaymentMethodsType | undefined;
    public PaymentMethodsEnum = PaymentMethods;
    public paymentMethodSelected: PaymentMethodsType | null = null;
    private unsubscribe$: Subject<void> = new Subject<void>();

    /**
     * This variable do not define is the cart is above the threshold, is a configuration to get the payment method selected based on section
     */
    @Input() aboveThreshold: boolean = false;
    @Output() eventOnSelectPaypal: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private paymentMethodsService: PaymentMethodsService,
        private paymentMethodsHandlerService: PaymentMethodsHandlerService
    ) {}

    ngOnInit(): void {
        this.subscribePaypal();
        this.subscribePaymentMethodSelected();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribePaypal(): void {
        this.paymentMethodsService
            .getPaymentMethodsByType$(PaymentMethods.PAYPAL)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (paypal: PaymentMethod | undefined) => {
                    this.paypal = paypal?.name;
                },
            });
    }

    selectPaymentMethod(): void {
        this.eventOnSelectPaypal.emit(PaymentMethods.PAYPAL);
    }

    subscribePaymentMethodSelected(): void {
        this.paymentMethodsHandlerService
            .getPaymentMethodSelected$(this.aboveThreshold)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((paymentMethodSelected) => {
                this.paymentMethodSelected = paymentMethodSelected?.method || null;
            });
    }
}
